module.exports = __webpack_public_path__ + "static/media/img-works-01.3a8b946f.jpg";